import PropTypes from "prop-types";
import ReactDOM from "react-dom";

const Portal = ({ children, to }) => {
	return ReactDOM.createPortal(children, to);
};

export default Portal;

Portal.propTypes = {
	children: PropTypes.node.isRequired,
	to: PropTypes.instanceOf(Element).isRequired,
};
